export const getUrlFromFormat = (url: string, formats: number[] | null, width: number) => {
    if (!formats){
        return url
    }

    if (formats.length === 0){
        return url
    }

    const formatExtension = 'jpg' as const//we only use jpg
    const urlSplit = url.split('.');
    const originalFileExtension = urlSplit[urlSplit.length - 1];
    const baseUrl = url.replace(`.${originalFileExtension}`, '');

    const bestFormatForWidth = getFormatsByDiff(formats, width);

    if (!bestFormatForWidth){
        return url
    }

    return `${baseUrl}-${bestFormatForWidth.format}.${formatExtension}`;
}


export const getFormatsByDiff = (formats: number[], width: number) => {
    let diffs = formats.map((f, idx) => {
        return {
            idx,
            diff: Math.abs(width - f),
        }
    })

    diffs = diffs.sort((a, b) => a.diff - b.diff);


    //grab format from the smallest diff of the width wanted
    return {
        idx: diffs[0].idx,
        format: formats[diffs[0].idx],
    }
}
